class ReglementCondition {
    constructor(data) {
      this.Id = data.Id;
      this.Name = data.Name;
    }
  }
  
  export default ReglementCondition;
  